export const AI_DEEP_RESEARCH_REPORT_RETENTION_DAYS = 30;
export const AI_DEEP_RESEARCH_QUERY_HISTORY_RETENTION_DAYS = 32;
export const AI_DEEP_RESEARCH_RUN_STATUSES = [
    'queued',
    'running',
    'completed',
    'partially_completed',
    'failed',
    'cancelled',
];
export const AI_DEEP_RESEARCH_TERMINAL_STATUSES = [
    'completed',
    'partially_completed',
    'failed',
    'cancelled',
];
export const AI_DEEP_RESEARCH_ENTRY_POINTS = ['homepage', 'ask_ai'];
export const AI_DEEP_RESEARCH_TERMINAL_REASONS = [
    'user_cancellation',
    'permission_revoked',
    'tool_limit',
    'query_limit',
    'token_limit',
    'time_limit',
    'no_relevant_data',
    'provider_error',
    'internal_error',
];
export const isAiDeepResearchRunTerminal = (status) => AI_DEEP_RESEARCH_TERMINAL_STATUSES.includes(status);
export const AI_DEEP_RESEARCH_DEFAULT_LIMITS = {
    maxTokens: 10000000,
    maxSteps: 16,
    maxToolCalls: 24,
    maxWarehouseQueries: 15,
    deadlineMs: 600000,
};
/**
 * Fraction of a limit at which the run stops expanding — it stops delegating
 * and starts finalizing — so it lands a report instead of hitting the ceiling.
 */
export const AI_DEEP_RESEARCH_SOFT_STOP_RATIO = 0.75;
/**
 * Rows of a query result written into model context. The query still returns
 * (and the server still keeps) every row up to the run's row limit — this only
 * bounds what is replayed through the conversation on every later step.
 */
export const AI_DEEP_RESEARCH_MAX_CONTEXT_ROWS = 50;
/**
 * The hard ceiling on data workers a coordinator may delegate to in one run.
 * Delegation is the coordinator's choice; this cap is enforced server-side.
 */
export const AI_DEEP_RESEARCH_MAX_WORKERS = 2;
export const AI_DEEP_RESEARCH_CONFIDENCE_LEVELS = [
    'low',
    'medium',
    'high',
];
export const AI_DEEP_RESEARCH_EVENT_TYPES = [
    'status_changed',
    'cancellation_requested',
    'progress',
    'report_adjusted',
];
export const AI_DEEP_RESEARCH_PHASES = [
    'planning',
    'investigating',
    'validating',
    'synthesizing',
];
export const AI_DEEP_RESEARCH_ACTIVITIES = [
    'lightdash_metadata',
    'warehouse_query',
    'web_search',
    'web_fetch',
    'reporting',
];
//# sourceMappingURL=types.js.map